import { Socket, Manager } from "socket.io-client";
import InfoNotificationAlert from "../../domain/entities/InfoNotificationAlert";

export interface AdminSocketDataSource {
	connectSocket(): Promise<void>;
	disconnectSocket(): Promise<void>;
	onNotificationAlert(callback: (data: InfoNotificationAlert) => void): void;
}

export class AdminSocketDataSourceImpl implements AdminSocketDataSource {
	private socket: Socket | null = null;
	private onNotificationAlertCallback: ((data: InfoNotificationAlert) => void) | null = null;

	async connectSocket(): Promise<void> {
		const token = localStorage.getItem("userToken");
		if (!token) {
			throw new Error("No se encontró el token");
		}

		const manager = new Manager(`${process.env.REACT_APP_UNJABBED}/socket.io/socket.io.js`, {
			transports: ["websocket"],
			extraHeaders: {
				authorization: `Bearer ${token}`,
			},
		});
		

		this.socket = manager.socket("/admin", { auth: { token } });
		this.socket.connect();

		this.socket.on("admin_notification", (data) => {
			if (this.onNotificationAlertCallback) {
				this.onNotificationAlertCallback(data);
				console.log(data);
			}
		});

		this.socket.on("error", (data) => {
			console.error("Error en el socket:", data);
		});
	}

	disconnectSocket(): Promise<void> {
		return new Promise((resolve) => {
			if (this.socket) {
				this.socket.disconnect();
				this.socket = null;
			}
			resolve();
		});
	}
	onNotificationAlert(callback: (data: InfoNotificationAlert) => void): void {
		this.onNotificationAlertCallback = callback;
	}
}
